import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import moment from "moment"
// Antd
import { Typography, Row, Col, Icon } from "antd";

// Formik
import { FastField, Formik } from "formik";

// Yup
import * as Yup from "yup";

// Component
import Button from "../../../../components/Buttons";
import Input from "../../../../components/Common/Input";
import typo, { MESSAGE } from "../../../../constants/dictionaries";
import Select from "../../../../components/Common/Select";
import message from "../../../../components/Messages";
import NumberField from "../../../../components/Common/NumberField"
import constant from "../../../../constants/constant";
import TramQuanTracModel from "../../../../models/QuanTrac_qn/TramQuanTrac"
// Colors
import colors from "../../../../constants/colors";

// Styled components
import styles from "./Modal.module.scss";
import helper from "../../../../helper/helper";
import Api_tnn from "../../../../api/api.tnn";
import Api_quantrac from "../../../../api/api.quantrac";
import Api from "../../../../api";
import Api_spatial from "../../../../api/api.spatial";
import SongVaLuuVuc from '../../../../components/CongTrinh/SongVaLuuVuc';
const { Text } = Typography;

const ControllerForm = styled.div`
  // border: 1px solid #c8ced3;
  border-radius: 5px;
  background: ${colors.white};
`;
const ControllerInput = styled.div`
  padding: 0 20px 0 20px;
`;
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;
const dataCap = [
  { id: 1, ten: "Trung ương" },
  { id: 2, ten: "Địa phương" },
]
const loaiTramQT = [
  { id: 1, ten: "Trạm quan trắc" },
  { id: 2, ten: "Điểm quan trắc" },
]
// Validations for add user
const addOrEditSchema = Yup.object().shape({
  tenTram: Yup.string().required(typo.cscore_input_Required),
  thongTinChung_Id: Yup.string().required(typo.cscore_input_Required),
});


class TramQT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      data_KinhTuyenTruc: [],
      data_tinh: [],
      data_huyen: [],
      data_xa: [],
      data_MuiChieu: [],
      selectTinh: undefined,
      selectHuyen: undefined,
      selectXa: undefined,
      initialValues: {},
      years: [],
    };
  }

  componentDidMount() {
    this.getApiTinhs();
    this.getApiMuiChieus();
    this.GetBVMTs()
    this.getYears()
  }
  getYears = () => {
    var c_year = new Date().getFullYear(); var years = []
    for (var i = c_year + 20; i >= 1975; i--) { years.push({ year: i }) }
    this.setState({ years: years })
  }
  GetBVMTs = () => {
    const { isEdit, selectedRow, loaiTramQuanTrac, dulieu } = this.props
    new Api_quantrac()
      .GetBVMT({ token: this.props.user.access_token, id: isEdit ? selectedRow.thongTinChung_Id : selectedRow.id })
      .then(res => {
        if (isEdit) {
          this.getApiHuyenByTinhs(selectedRow.maTinh ? selectedRow.maTinh : constant.MA_TINH);
          this.getApiXaByHuyens(selectedRow.maHuyen ? selectedRow.maHuyen : undefined);
          this.GetApidmkinhtuyentrucs(selectedRow.loai_KTT ? selectedRow.loai_KTT : undefined)
          this.setState({
            initialValues: {
              ...selectedRow,
              loai_KTT: selectedRow.loai_KTT ? selectedRow.loai_KTT : constant.CAP_TRIEN_KHAI,
              ten_KTT: selectedRow.ten_KTT ? selectedRow.ten_KTT : constant.KINH_TUYEN_TRUC_TEN,
              kinhTuyenTruc: selectedRow.kinhTuyenTruc ? selectedRow.kinhTuyenTruc : constant.KINH_TUYEN_TRUC,
              doanhNghiep_Ten: res.doanhNghiep_Ten,
              doanhNghiep_DiaChi: res.doanhNghiep_DiaChi,
              maTinh: selectedRow.maTinh ? selectedRow.maTinh : constant.MA_TINH,
              viewSQD: res.soQD + " (" + moment(res.ngayKy).format("DD-MM-YYYY") + ")"

            },
            selectTinh: selectedRow.maTinh ? selectedRow.maTinh : undefined,
            selectHuyen: selectedRow.maHuyen ? selectedRow.maHuyen : undefined,
            selectXa: selectedRow.maXa ? selectedRow.maXa : undefined,
          })
        } else {
          if(dulieu){
            this.setState({
              initialValues: {
                loai_KTT: constant.CAP_TRIEN_KHAI,
                ten_KTT: constant.KINH_TUYEN_TRUC_TEN,
                kinhTuyenTruc: constant.KINH_TUYEN_TRUC,
                maTinh: constant.CAP_TRIEN_KHAI === 2 ? constant.MA_TINH : undefined,
                muiChieu: constant.CAP_TRIEN_KHAI === 1 ? 6 : 3,
                loaiTram: 2,
                thongTinChung_Id: selectedRow.id,
                doanhNghiep_Ten: selectedRow.doanhNghiep_Ten,
                doanhNghiep_DiaChi: selectedRow.doanhNghiep_DiaChi,
                viewSQD: res.soQD + " (" + moment(res.ngayKy).format("DD-MM-YYYY") + ")"
              },
            })
          } else {
            this.setState({
              initialValues: {
                ...selectedRow,
                loai_KTT: constant.CAP_TRIEN_KHAI,
                ten_KTT: constant.KINH_TUYEN_TRUC_TEN,
                kinhTuyenTruc: constant.KINH_TUYEN_TRUC,
                maTinh: constant.CAP_TRIEN_KHAI === 2 ? constant.MA_TINH : undefined,
                muiChieu: constant.CAP_TRIEN_KHAI === 1 ? 6 : 3,
                loaiTram: loaiTramQuanTrac,
              },
            })
          }
          if (constant.CAP_TRIEN_KHAI === 2) {
            this.getApiHuyenByTinhs(constant.MA_TINH);
            this.GetApidmkinhtuyentrucs(2)
          } else if (constant.CAP_TRIEN_KHAI === 1) {
            this.GetApidmkinhtuyentrucs(1)
          }
        }
      })
      .catch(err => {
        message.error(err.message)
      });
  };

  GetApidmkinhtuyentrucs = (cap) => {
    new Api()
      .Getdmkinhtuyentrucs({ token: this.props.user.access_token, page: "0", size: "0", cap: cap })
      .then(res => { this.setState({ data_KinhTuyenTruc: res.data }); })
      .catch(err => {
        message.error(err.message)
      });
  };
  getApiTinhs = () => {
    new Api()
      .getTinhs({ token: this.props.user.access_token, })
      .then(res => { this.setState({ data_tinh: res }); });
  };
  getApiHuyenByTinhs = (maTinh) => {
    new Api()
      .getHuyenByTinhs({
        token: this.props.user.access_token,
        maTinh: maTinh
      })
      .then(res => { this.setState({ data_huyen: res }) });
  };
  getApiXaByHuyens = (mahuyen) => {
    new Api()
      .getXaByHuyens({
        token: this.props.user.access_token,
        maHuyen: mahuyen
      })
      .then(res => { this.setState({ data_xa: res }) });
  };
  getApiMuiChieus = () => {
    new Api_tnn()
      .GetMuiChieus({ token: this.props.user.access_token, })
      .then(res => { this.setState({ data_MuiChieu: res }); });
  };

  SelectTinh = (value, name) => {
    this.setState({
      data_xa: [],
      selectTinh: value,
    })
    this.getApiHuyenByTinhs(value)
  }

  SelectHuyen = (value, name) => {
    this.setState({
      selectHuyen: value
    })
    this.getApiXaByHuyens(value)
  }
  SelectXa = (value, name) => {
    this.setState({
      selectXa: value
    })
  }
  onSelectLKTT = (value) => {
    this.GetApidmkinhtuyentrucs(value)
  }
  render() {
    const {
      handleCloseModal,
      selectedRow,
      isEdit,
      handleAdd,
      mode
    } = this.props;
    const { years, data_xa, data_huyen, data_tinh, selectXa, selectHuyen, selectTinh, data_KinhTuyenTruc, data_MuiChieu, initialValues } = this.state

    return (
      <div>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={addOrEditSchema}
          onSubmit={async (values, actions) => {
            var tenDVHCTram = helper.gettenDVHC(data_xa, data_huyen, data_tinh, selectXa, selectHuyen, selectTinh)
            const { degree, minute } = await helper.getKTTById(this.props.user.access_token, values.kinhTuyenTruc);
            if (isEdit) {
              new Api_quantrac()
                .PutBVMT_TramQuanTrac({
                  token: this.props.user.access_token,
                  data: { ...values, tenDVHC: tenDVHCTram },
                  id: selectedRow.id
                })
                .then(res => {
                  if (values.toaDo !== undefined && values.toaDo !== null && values.toaDo !== "") {
                    new Api_spatial()
                      .LuuQuanTracBVMTDiem({
                        token: this.props.user.access_token,
                        obj: new TramQuanTracModel(values),
                        ktt_do: degree,
                        ktt_phut: minute,
                        muichieu: values.muiChieu
                      })
                      .then(res => {
                        // message.success(MESSAGE.CSCORE_UPDATE_SUCCESS);
                        actions.resetForm({});
                      })
                      .catch(res => {
                        // message.warning(MESSAGE.CSCORE_TOA_DO_DEM)
                      })
                  }
                  handleAdd();
                  message.success(MESSAGE.CSCORE_UPDATE_SUCCESS);
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
            else {
              new Api_quantrac()
                .PostBVMT_TramQuanTrac({
                  token: this.props.user.access_token,
                  data: { ...values, tenDVHC: tenDVHCTram, id: 0 },
                })
                .then(res => {
                  if (values.toaDo !== undefined && values.toaDo !== null && values.toaDo !== "") {
                    new Api_spatial()
                      .LuuQuanTracBVMTDiem({
                        token: this.props.user.access_token,
                        obj: new TramQuanTracModel({ ...values, id: res.id }),
                        ktt_do: degree,
                        ktt_phut: minute,
                        muichieu: values.muiChieu
                      })
                      .then(res => {
                        // message.success(MESSAGE.CSCORE_ADD_SUCCESS);

                        actions.resetForm({});
                      })
                      .catch(res => {
                        // message.warning(MESSAGE.CSCORE_TOA_DO_DEM)
                      })
                  }
                  handleAdd();
                  message.success(MESSAGE.CSCORE_ADD_SUCCESS);
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
          }}
          render={({
            errors,
            handleSubmit,
            touched,
            dirty,
            values,
            setFieldValue
          }) => (
              <form onSubmit={handleSubmit} autoComplete="false">
                <ControllerForm>
                  <Row>
                    <Col span={12}>
                      <ControllerInput>
                        <Select
                          dataSource={loaiTramQT}
                          onChange={(value) => setFieldValue("loaiTram", value)}
                          placeholder={helper.genSelectPL(typo.cscore_phan_loai_quan_trac)}
                          label={typo.cscore_Loai_quan_trac}
                          width="100%"
                          name="ten"
                          name_value="id"
                          defaultValue={values.loaiTram}
                          key={values.loaiTram}
                          disabled={isEdit ? true : false}

                        />
                         <FastField name="viewSQD" render={({ field }) => (
                          <Input placeholder={typo.cscore_soQuyetDinh} label={typo.cscore_soQuyetDinh} disabled={true} mandatory={false} {...field} />)} />

                        <FastField name="doanhNghiep_Ten" render={({ field }) => (
                          <Input placeholder={typo.cscore_ten_doanh_nghiep} label={typo.cscore_ten_doanh_nghiep} disabled={true} mandatory={false} {...field} />)} />

                        <FastField name="doanhNghiep_DiaChi" render={({ field }) => (
                          <Input placeholder={typo.cscore_dia_chi_doanh_nghiep} label={typo.cscore_dia_chi_doanh_nghiep} mandatory={false} disabled={true} {...field} />)} />

                        <FastField name="soHieu" render={({ field }) => (
                          <Input placeholder={typo.cscore_so_hieu} label={typo.cscore_so_hieu} mandatory={false} {...field} />)} />
                        {touched.soHieu && (<Text type="danger" className={styles.textFont}>{errors.soHieu}</Text>
                        )}

                        <FastField name="tenTram" render={({ field }) => (
                          <Input placeholder={typo.cscore_ten_tram} label={typo.cscore_ten_tram} {...field} />)} />
                        {touched.tenTram && (<Text type="danger" className={styles.textFont}>{errors.tenTram}</Text>
                        )}

                        <FastField name="hangTram" render={({ field }) => (
                          <Input placeholder={typo.cscore_hang_tram} label={typo.cscore_hang_tram} mandatory={false} {...field} />)} />
                        {touched.hangTram && (<Text type="danger" className={styles.textFont}>{errors.hangTram}</Text>
                        )}
                        <Select
                          mandatory={false}
                          placeholder={helper.genSelectPL(typo.cscore_province_placeholder)}
                          label={typo.cscore_province}
                          onChange={(value, name) => {
                            setFieldValue("maTinh", value);
                            { setFieldValue("maHuyen", undefined) };
                            { setFieldValue("maXa", undefined) };
                            this.SelectTinh(value, name)
                          }}
                          dataSource={data_tinh}
                          width="100%"
                          name="tenDVHC"
                          name_value="maTinh"
                          value={values.maTinh}
                        />

                        <Select
                          mandatory={false}
                          placeholder={helper.genSelectPL(typo.cscore_district_placeholder)}
                          label={typo.cscore_district}
                          onChange={(value, name) => {
                            setFieldValue("maHuyen", value);
                            { setFieldValue("maXa", undefined) };
                            this.SelectHuyen(value, name)
                          }}
                          dataSource={data_huyen}
                          width="100%"
                          name="tenDVHC"
                          name_value="maHuyen"
                          value={values.maHuyen}
                        />

                        <Select
                          mandatory={false}
                          placeholder={helper.genSelectPL(typo.cscore_ward_placeholder)}
                          label={typo.cscore_ward}
                          onChange={(value, name) => {
                            setFieldValue("maXa", value);
                            this.SelectXa(value, name)
                          }}
                          dataSource={data_xa}
                          width="100%"
                          name="tenDVHC"
                          name_value="maXa"
                          value={values.maXa}
                        />

                      </ControllerInput>
                    </Col>
                    <Col span={12}>
                      <ControllerInput>

                        <FastField name="diaDiem" render={({ field }) => (
                          <Input placeholder={typo.cscore_hydropower_place} label={typo.cscore_hydropower_place} mandatory={false} {...field} />)} />
                        {touched.diaDiem && (<Text type="danger" className={styles.textFont}>{errors.diaDiem}</Text>
                        )}

                        <FastField name="donViQuanLy" render={({ field }) => (
                          <Input placeholder={typo.cscore_donViQuanLy} label={typo.cscore_donViQuanLy} mandatory={false} {...field} />)} />
                        {touched.donViQuanLy && (<Text type="danger" className={styles.textFont}>{errors.donViQuanLy}</Text>
                        )}
                        <FastField name="toaDo" validate={helper.validateToaDo} render={({ field }) => (<Input mandatory={false} label={typo.cscore_toa_do} {...field} placeholder={typo.cscore_toaDo} />)} />
                        {touched.toaDo && (<Text type="danger">{errors.toaDo}</Text>)}

                        <Select
                          dataSource={dataCap}
                          label={typo.cscore_loaiKTT}
                          defaultValue={values.loai_KTT ? Number(values.loai_KTT) : undefined}
                          onChange={(value) => { setFieldValue("loai_KTT", value); setFieldValue("kinhTuyenTruc", undefined); this.onSelectLKTT(value) }}
                          placeholder={helper.genSelectPL(typo.cscore_chon_cap)}
                          mandatory={false}
                          width="100%"
                          name="ten"
                          name_value="id"
                          value={values.loai_KTT}
                        />
                        <Select
                          mandatory={false}
                          placeholder={helper.genSelectPL(typo.cscore_kinh_tuyen_truc)}
                          label={typo.cscore_kinh_tuyen_truc}
                          onChange={(value, name) => { setFieldValue("kinhTuyenTruc", value); setFieldValue("ten_KTT", name.props.children) }}
                          dataSource={this.state.data_KinhTuyenTruc}
                          width="100%"
                          name="ten"
                          name_value="id"
                          defaultValue={values.kinhTuyenTruc ? Number(values.kinhTuyenTruc) : undefined}
                          value={values.kinhTuyenTruc ? Number(values.kinhTuyenTruc) : undefined}
                        />

                        <Select
                          mandatory={false}
                          placeholder={helper.genSelectPL(typo.cscore_mui_chieu)}
                          label={typo.cscore_mui_chieu}
                          onChange={value => setFieldValue("muiChieu", value)}
                          dataSource={data_MuiChieu}
                          width="100%"
                          name="ten"
                          name_value="id"
                          value={values.muiChieu}
                        />
                        <Select
                          dataSource={years}
                          value={values.namXayDung ? Number(values.namXayDung) : undefined}
                          onChange={(value) => {setFieldValue("namXayDung", value)}}
                          label={typo.cscore_namXayDung}
                          placeholder={typo.cscore_namXayDung}
                          width="100%"
                          name="year"
                          name_value="year"
                          mandatory={false}
                        />
                        <Select
                          dataSource={values.namXayDung ? years.filter(e => e.year >= values.namXayDung) : years}
                          value={values.namSuDung ? Number(values.namSuDung) : undefined}
                          onChange={(value) => {setFieldValue("namSuDung", value) }}
                          label={typo.cscore_namSuDung}
                          placeholder={typo.cscore_namSuDung}
                          width="100%"
                          name="year"
                          name_value="year"
                          mandatory={false}
                        />

                        <SongVaLuuVuc
                          values={values}
                          setFieldValue={setFieldValue} />

                      </ControllerInput>
                    </Col>
                  </Row>

                  <ControllerButton>
                    {mode !== "view" &&
                    <button
                      className="ant-btn"
                      type="submit"
                      disabled={!isEmpty(errors) || !dirty}
                    >
                      <Icon type="save" style={{ marginRight: "8px" }} />
                      {typo.cscore_submit}
                    </button>}
                    <Button
                      type="cancel"
                      className={styles.buttonMargin}
                      onClick={handleCloseModal}
                    >
                      <Icon type="arrow-right" />
                      {typo.cscore_exit}
                    </Button>
                  </ControllerButton>
                </ControllerForm>
              </form>
            )}
        />
      </div>
    );
  }
}

TramQT.propTypes = {
  handleAddAccount: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool
};

export default TramQT;
